document.addEventListener(
  'turbo:before-cache',
  () => {
    [].forEach.call(document.querySelectorAll('.js-purchase-flash'), (e) => {
      e.parentElement.removeChild(e);
    });
  },
  false,
);
